var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctors3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-120"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.9,260.35h-3v-35.9a15,15,0,0,0-14-15.16,14.76,14.76,0,0,0-15.48,14,.73.73,0,0,1-.72.71h-1.55a.73.73,0,0,1-.73-.75,17.77,17.77,0,0,1,17.43-17c9.93-.17,18,8.29,18,18.22Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.06,
    y: 264.27,
    width: 21.32,
    height: 118.09,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.88,
    y: 264.27,
    width: 231,
    height: 118.09,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.88 288.86 186.88 288.86 186.88 290.86 243.63 290.86 243.63 382.36 245.63 382.36 245.63 290.86 300.84 290.86 300.84 382.36 302.84 382.36 302.84 290.86 358.04 290.86 358.04 382.36 360.04 382.36 360.04 290.86 417.88 290.86 417.88 288.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.88,341.36h0a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2v9A2,2,0,0,1,237.88,341.36Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.38,341.36h0a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2v9A2,2,0,0,1,251.38,341.36Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.29,341.36h0a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2v9A2,2,0,0,1,352.29,341.36Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.79,341.36h0a2,2,0,0,1-2-2v-9a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2v9A2,2,0,0,1,365.79,341.36Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.88,
    y: 261.68,
    width: 26.5,
    height: 5.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.88,
    y: 261.68,
    width: 238,
    height: 5.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.48,262.27H345.59a1.92,1.92,0,0,1-1.92-1.92h0a1.92,1.92,0,0,1,1.92-1.92h78.89a1.92,1.92,0,0,1,1.92,1.92h0A1.92,1.92,0,0,1,424.48,262.27Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.45,
    y: 255.2,
    width: 2.99,
    height: 3.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.73 256.15 400.16 256.15 401.25 249.5 404.64 249.5 405.73 256.15",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.33,
    y: 255.2,
    width: 2.99,
    height: 3.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.6 256.15 385.04 256.15 386.12 249.5 389.52 249.5 390.6 256.15",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.57 201.34 406.06 201.34 387.96 98.69 365.47 98.69 383.57 201.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "370.48 201.34 376.54 201.34 358.44 98.69 352.38 98.69 370.48 201.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.67 203.12 310.9 203.12 292.3 97.62 286.07 97.62 304.67 203.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.09 203.12 328.83 203.12 310.23 97.62 298.48 97.62 317.09 203.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.54,97.09H422v106H348.54Zm67.68,5.81H354.35v94.42h61.87Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.14,94.19h152.8V206H272.14Zm147,5.81H278V200.23H419.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.89,
    y: 94.44,
    width: 75.26,
    height: 111.35,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.16,96.6H95.89a2.16,2.16,0,0,1-2.15-2.16h0a2.16,2.16,0,0,1,2.15-2.16h75.27a2.16,2.16,0,0,1,2.15,2.16h0A2.16,2.16,0,0,1,171.16,96.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.16,208H95.89a2.16,2.16,0,0,1-2.15-2.16h0a2.15,2.15,0,0,1,2.15-2.16h75.27a2.15,2.15,0,0,1,2.15,2.16h0A2.16,2.16,0,0,1,171.16,208Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.42,151.67a24.35,24.35,0,0,0-.9-6V131.54c0-7.29-5.92-10.43-13.21-10.43s-13.22,3.14-13.22,10.43v14.11a24.35,24.35,0,0,0-.9,6,14,14,0,0,0,3.24,9v31a4.48,4.48,0,0,0,9,0v-26a13.17,13.17,0,0,0,3.83,0v26a4.48,4.48,0,0,0,9,0v-31A14,14,0,0,0,147.42,151.67Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.93,151.5a2.79,2.79,0,1,1-5.57,0V127.39a2.79,2.79,0,1,1,5.57,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.25,151.5a2.79,2.79,0,1,1-5.57,0V127.39a2.79,2.79,0,1,1,5.57,0Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.31,
    cy: 111.42,
    r: 7.33,
    transform: "translate(-39.74 126.89) rotate(-45)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,150.23a10.44,10.44,0,0,1-20.87,0c0-5.77,4.67-14,10.44-14S143.74,144.46,143.74,150.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.58,141.57a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,135.58,141.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.13,146.78c0-1.56-1.26-1.9-2.82-1.9s-2.83.34-2.83,1.9v2.83c0,1.56,1.26,1.91,2.83,1.91s2.82-.35,2.82-1.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.67,158.5h0a.92.92,0,0,1-.91-.92v-4.1a.92.92,0,0,1,.91-.92h0a.92.92,0,0,1,.92.92v4.1A.92.92,0,0,1,131.67,158.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.94,158.5h0a.92.92,0,0,1-.92-.92v-4.1a.92.92,0,0,1,.92-.92h0a.92.92,0,0,1,.92.92v4.1A.93.93,0,0,1,134.94,158.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.9,149.7h0a.92.92,0,0,1,0-1.3l2.9-2.9a.91.91,0,0,1,1.29,0h0a.92.92,0,0,1,0,1.3l-2.9,2.9A.91.91,0,0,1,124.9,149.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.72,149.7h0a.94.94,0,0,0,0-1.3l-2.91-2.9a.91.91,0,0,0-1.29,0h0a.92.92,0,0,0,0,1.3l2.9,2.9A.92.92,0,0,0,141.72,149.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.48,
    y: 311.61,
    width: 42.25,
    height: 6.5,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.26,315.36h39.45a3.27,3.27,0,0,1,3.27,3.27v63.73a0,0,0,0,1,0,0H68a0,0,0,0,1,0,0V318.63a3.27,3.27,0,0,1,3.27-3.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.98,
    y: 303.61,
    width: 46,
    height: 10,
    rx: 3.61,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.48 382.36 59.98 382.36 59.98 379.36 81.48 377.36 81.48 382.36",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-120"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-120",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bassinet--inject-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.73,276.66V406.21h3.87V293.7h97.67V406.21h3.87V276.66A14.13,14.13,0,0,0,240,262.54H162.85A14.14,14.14,0,0,0,148.73,276.66Zm3.87,13.17V276.66a10.26,10.26,0,0,1,10.25-10.25H240a10.26,10.26,0,0,1,10.25,10.25v13.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.73,276.66V406.21h3.87V293.7h97.67V406.21h3.87V276.66A14.13,14.13,0,0,0,240,262.54H162.85A14.14,14.14,0,0,0,148.73,276.66Zm3.87,13.17V276.66a10.26,10.26,0,0,1,10.25-10.25H240a10.26,10.26,0,0,1,10.25,10.25v13.17Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.58,243l25.25,15.25H255l-2.7,23.58a9,9,0,0,1-8.93,8h-119a9,9,0,0,1-8.93-8L111,243Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.58,243l25.25,15.25H255l-2.7,23.58a9,9,0,0,1-8.93,8h-119a9,9,0,0,1-8.93-8L111,243Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.58,243l25.24,15.25H225l-2.69,23.58a9,9,0,0,1-8.93,8h-89a9,9,0,0,1-8.93-8L111,243Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.58,243l25.24,15.25H225l-2.69,23.58a9,9,0,0,1-8.93,8h-89a9,9,0,0,1-8.93-8L111,243Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,241.34h33.07l25.25,15.25h11.74V260H191.19l-25.25-15.24H133.81a1.7,1.7,0,0,1,0-3.39Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.81,241.34h33.07l25.25,15.25h11.74V260H191.19l-25.25-15.24H133.81a1.7,1.7,0,0,1,0-3.39Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.35,260h94.29a1.69,1.69,0,0,0,1.69-1.69h0a1.69,1.69,0,0,0-1.69-1.69H163.29l-25.24-15.25H109.33a1.7,1.7,0,0,0-1.7,1.69h0a1.7,1.7,0,0,0,1.7,1.7h27.78Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.35,260h94.29a1.69,1.69,0,0,0,1.69-1.69h0a1.69,1.69,0,0,0-1.69-1.69H163.29l-25.24-15.25H109.33a1.7,1.7,0,0,0-1.7,1.69h0a1.7,1.7,0,0,0,1.7,1.7h27.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.48,258.28a1.69,1.69,0,0,0-1.7-1.69h31.86a1.69,1.69,0,0,1,0,3.38H224.78A1.7,1.7,0,0,0,226.48,258.28Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.85,
    y: 289.83,
    width: 101.54,
    height: 3.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.85,
    y: 289.83,
    width: 101.54,
    height: 3.87,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 211.97,
    y: 289.83,
    width: 5.42,
    height: 3.87,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.85,
    y: 289.83,
    width: 4.83,
    height: 3.87,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.92,406.21h3.87V276.66A10.26,10.26,0,0,1,128,266.41h77.17a10.26,10.26,0,0,1,10.25,10.25V406.21h3.87V276.66a14.14,14.14,0,0,0-14.12-14.12H128a14.13,14.13,0,0,0-14.12,14.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.92,406.21h3.87V276.66A10.26,10.26,0,0,1,128,266.41h77.17a10.26,10.26,0,0,1,10.25,10.25V406.21h3.87V276.66a14.14,14.14,0,0,0-14.12-14.12H128a14.13,14.13,0,0,0-14.12,14.12Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M253.82,409.4a6,6,0,1,0,6-6A6,6,0,0,0,253.82,409.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.82,409.4a6,6,0,1,0,6-6A6,6,0,0,0,253.82,409.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.51,409.4a3.28,3.28,0,1,0,3.27-3.27A3.27,3.27,0,0,0,256.51,409.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6,411.36h8.74a1.94,1.94,0,0,0,1.15-3.5l-8.74-6.43a1.94,1.94,0,0,0-3.09,1.57v6.42A1.94,1.94,0,0,0,250.6,411.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.6,411.36h8.74a1.94,1.94,0,0,0,1.15-3.5l-8.74-6.43a1.94,1.94,0,0,0-3.09,1.57v6.42A1.94,1.94,0,0,0,250.6,411.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84,409.4a6,6,0,1,0,6-6A6,6,0,0,0,219.84,409.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.84,409.4a6,6,0,1,0,6-6A6,6,0,0,0,219.84,409.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.53,409.4a3.28,3.28,0,1,0,3.27-3.27A3.28,3.28,0,0,0,222.53,409.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.63,411.36h8.74a1.94,1.94,0,0,0,1.15-3.5l-8.74-6.43a2,2,0,0,0-3.1,1.57v6.42A1.94,1.94,0,0,0,216.63,411.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.63,411.36h8.74a1.94,1.94,0,0,0,1.15-3.5l-8.74-6.43a2,2,0,0,0-3.1,1.57v6.42A1.94,1.94,0,0,0,216.63,411.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,409.4a6,6,0,1,0,6-6A6,6,0,0,0,152.64,409.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,409.4a6,6,0,1,0,6-6A6,6,0,0,0,152.64,409.4Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.33,409.4a3.28,3.28,0,1,0,3.27-3.27A3.27,3.27,0,0,0,155.33,409.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,411.36h8.73a1.94,1.94,0,0,0,1.16-3.5l-8.74-6.43a2,2,0,0,0-3.1,1.57v6.42A1.94,1.94,0,0,0,149.43,411.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.43,411.36h8.73a1.94,1.94,0,0,0,1.16-3.5l-8.74-6.43a2,2,0,0,0-3.1,1.57v6.42A1.94,1.94,0,0,0,149.43,411.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08,409.4a6,6,0,1,0,6-6A6,6,0,0,0,118.08,409.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08,409.4a6,6,0,1,0,6-6A6,6,0,0,0,118.08,409.4Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,409.4a3.28,3.28,0,1,0,3.28-3.27A3.28,3.28,0,0,0,120.76,409.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.86,411.36h8.74a1.94,1.94,0,0,0,1.15-3.5L116,401.43a1.94,1.94,0,0,0-3.09,1.57v6.42A1.94,1.94,0,0,0,114.86,411.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.86,411.36h8.74a1.94,1.94,0,0,0,1.15-3.5L116,401.43a1.94,1.94,0,0,0-3.09,1.57v6.42A1.94,1.94,0,0,0,114.86,411.36Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-120"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.6,158.32s14.89,19.75,16.65,27.39S259,198.62,259,198.62s-6.69,9.87-10.12,7.48.47-5.89.47-5.89,1.18-5.58,5.18-5.89l1.76-5.26-9.69-11.15S240.35,168.83,247.6,158.32Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.38,175.47a18.49,18.49,0,0,0-11.58,8.39s-7.86-6.7-6.9-19.86,5.6-7.3,7.28-5.21C253,162.22,261.38,175.47,261.38,175.47Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.28,160.24c-.42-.58-.79-1.07-1.1-1.45-1.68-2.09-6.33-8-7.28,5.2s6.9,19.87,6.9,19.87a19.52,19.52,0,0,1,6.07-6.08Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.87,173.1c-6.44,1.31-10.67,6.28-12.19,8.36a16.71,16.71,0,0,0,2.12,2.4,18.49,18.49,0,0,1,11.58-8.39Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.21,201c-1-2.25-4.91-2.53-7.32-2.47a11.16,11.16,0,0,0-.55,1.69s-3.89,3.51-.47,5.89C251.19,207.72,255,203.74,257.21,201Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.21 382.64 245.21 405.5 254.05 404.94 254.61 381.69 240.21 382.64",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.86,223.18s5.42,27.4,6.69,81.56-2.22,89.78-2.22,89.78-7.49,5-14,.27c0,0-11.21-51.5-12.48-92,0,0-8.6-51.93-5.74-79.65Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.86,223.18s5.42,27.4,6.69,81.56-2.22,89.78-2.22,89.78-7.49,5-14,.27c0,0-11.21-51.5-12.48-92,0,0-8.6-51.93-5.74-79.65Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,251.85l-2.42,7.63c1.8,22.39,5.27,43.35,5.27,43.35.06,1.81.14,3.63.23,5.45,8.41-35.59,2.32-58.34,2.32-58.34Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.19,392.93a17.19,17.19,0,0,0,13.77-.18,1.69,1.69,0,0,1,2.27,1.81h0a1.74,1.74,0,0,1-1.05,1.46,24.39,24.39,0,0,1-9.14,1.75c-4.36,0-6.52-1.35-7.39-2.1a1.63,1.63,0,0,1-.54-1h0A1.55,1.55,0,0,1,241.19,392.93Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.19,392.93a17.19,17.19,0,0,0,13.77-.18,1.69,1.69,0,0,1,2.27,1.81h0a1.74,1.74,0,0,1-1.05,1.46,24.39,24.39,0,0,1-9.14,1.75c-4.36,0-6.52-1.35-7.39-2.1a1.63,1.63,0,0,1-.54-1h0A1.55,1.55,0,0,1,241.19,392.93Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.16,403.06l-10,.22a.92.92,0,0,0-.89.74l-1.91,9.4a1.56,1.56,0,0,0,1.19,1.83l.33,0c4.15-.15,7.83-.44,13-.53,6.1-.11,4.56.65,11.74.62,4.32,0,5-4.95,3.18-5.15-8.4-.91-10.87-3.42-14.15-6.36A3.72,3.72,0,0,0,254.16,403.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.18 381.68 194.35 404.54 204.47 405.25 207.57 382 193.18 381.68",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.93,223.18s-7.32,63.72-11.79,92.71-15.61,75.51-15.61,75.51-8.92,4.15-14.33-2.86c0,0-6.59-40.47,1.48-78.06,0,0-4.35-53.85,3.29-74.24l4.15-15.61Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.93,223.18s-7.32,63.72-11.79,92.71-15.61,75.51-15.61,75.51-8.92,4.15-14.33-2.86c0,0-6.59-40.47,1.48-78.06,0,0-4.35-53.85,3.29-74.24l4.15-15.61Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.18,387.41a17.19,17.19,0,0,0,13.5,2.68,1.7,1.7,0,0,1,1.85,2.25h0a1.76,1.76,0,0,1-1.33,1.21,24.54,24.54,0,0,1-9.31-.19c-4.26-.91-6.1-2.68-6.78-3.59a1.6,1.6,0,0,1-.33-1.08h0A1.55,1.55,0,0,1,193.18,387.41Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.18,387.41a17.19,17.19,0,0,0,13.5,2.68,1.7,1.7,0,0,1,1.85,2.25h0a1.76,1.76,0,0,1-1.33,1.21,24.54,24.54,0,0,1-9.31-.19c-4.26-.91-6.1-2.68-6.78-3.59a1.6,1.6,0,0,1-.33-1.08h0A1.55,1.55,0,0,1,193.18,387.41Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.15,399.52l-9.61-2.64a.92.92,0,0,0-1.07.46L189,405.81a1.56,1.56,0,0,0,.62,2.09,1.66,1.66,0,0,0,.31.12c4,1,7.63,1.81,12.61,3.2,5.88,1.64,4.19,1.93,11.07,3.95,4.15,1.21,6.23-3.31,4.53-4-7.8-3.26-9.44-6.37-11.76-10.13A3.73,3.73,0,0,0,204.15,399.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.81,228.7l1.34,9.36a6.35,6.35,0,0,0,6.6,5.43,112,112,0,0,0,13.62-1.41s-5.29-38.17-3-53c.81-5.16,2.46-10.75.29-20.91-.83-3.88.35-11-7.51-14s-34.19-3.83-41.63,3c0,0,1.28,32.07-.23,49.67-1.18,13.83-7.63,34-7.63,34s12.44,2,27.7,2.64a8,8,0,0,0,8.05-5.88Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.6,152.43l8.5,7.9,4.24,3.32,5.27,4.3,1.81-4,1.06-6.58v-3l-1.21-1.87A88.4,88.4,0,0,0,216.6,152.43Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.78,161.62s3.71,8.7,1.64,20.89,3,15.84,3,15.84l-10.28,2.37-5.25-6.13,3.58-21.51s.16-.8,1.43-6.77l1.28-6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.31,
    y: 216.38,
    width: 15.72,
    height: 1.64,
    transform: "translate(24.9 -22.22) rotate(6.24)",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.42,
    y: 217.05,
    width: 11.81,
    height: 1.43,
    transform: "translate(508.88 407.79) rotate(173.76)",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.77 180.17 216.45 178.89 216.45 177.51 228.77 178.78 228.77 180.17",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.73,206c-4.3-2.65-7.33-6.26-4.38-11.28,2.45-4.16,8.75-2.76,12.1-1.65a3,3,0,0,0,3.32-.91,14.12,14.12,0,0,1,8.15-4.81,4.4,4.4,0,0,0,3-2.08c2.38-4.15,8.94-13.87,16.41-10.33,9.4,4.46,7.17,19.59-5.26,28.36S224.9,210.4,217.73,206Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.73,206c-4.3-2.65-7.33-6.26-4.38-11.28,2.45-4.16,8.75-2.76,12.1-1.65a3,3,0,0,0,3.32-.91,14.12,14.12,0,0,1,8.15-4.81,4.4,4.4,0,0,0,3-2.08c2.38-4.15,8.94-13.87,16.41-10.33,9.4,4.46,7.17,19.59-5.26,28.36S224.9,210.4,217.73,206Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.94,150.89c5.79-.82,15.21-7.18,11.45-13.77s-3.41-8.84-1.49-11.26,5.84-10.94-1.09-12.68-3.62-5.1-11.86-5.18-19.3,3.16-18.18,13.43c-3.59,2.78-3.84,8.26-3.76,11.53C211,133,208.19,154.82,235.94,150.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.61,136.64c.66,4.67.88,13.15-3.61,15.93,0,0,4.79,3.79,14.48,8,7.05-3.78,3.92-6.74,3.92-6.74-6.46-1.7-5.87-5.45-4.38-8.94Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.6,140a9.46,9.46,0,0,0-.84,3.53c0,2.53,3.7,5,6.32,5.61a8.13,8.13,0,0,1,.62-3.49Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.4,128.73c2.13,8.12,2.85,11.61,7.83,15,7.49,5.11,17,.74,17.35-7.86.31-7.73-3.21-19.7-11.89-21.39a11.45,11.45,0,0,0-13.29,14.24Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.74,135.62a6.14,6.14,0,0,0,3.6,3c2.06.62,3.13-1.21,2.6-3.18-.48-1.76-2.14-4.22-4.22-4a2.77,2.77,0,0,0-2.35,3.14A3,3,0,0,0,217.74,135.62Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.23,112.43c-1.45,2.49,2.17,7.11,9.78,6.67,5.74-.34,12.94,5.83,12.35-.83C243.88,112.21,229.45,109.3,222.23,112.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.4,114.26c4,3,1.33,8.59-.59,11.08s-4.86,4.83-2.57,8.53,3.84,13.86-3.44,12.07-7-13.92-4.83-19.53S221.67,110.64,226.4,114.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.82,128.63a18.34,18.34,0,0,0,3.22,3.81,2.9,2.9,0,0,1-2.29.92Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.61,125.86a.34.34,0,0,1-.17,0,.32.32,0,0,1-.11-.45h0a3.9,3.9,0,0,1,3-1.95.34.34,0,0,1,.34.33.32.32,0,0,1-.31.34,3.26,3.26,0,0,0-2.48,1.63A.33.33,0,0,1,227.61,125.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.81,123.18a.33.33,0,0,1-.16-.05,3.27,3.27,0,0,0-3-.19.33.33,0,0,1-.45-.13h0a.34.34,0,0,1,.15-.45,3.91,3.91,0,0,1,3.58.2.35.35,0,0,1,.15.45.33.33,0,0,1-.32.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.88,128.46c.13.66.59,1.13,1,1s.69-.69.55-1.37-.59-1.13-1-1S230.75,127.78,230.88,128.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.44,127c.13.66.59,1.13,1,1.05s.68-.69.55-1.37-.59-1.13-1-1.05S238.3,126.29,238.44,127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.81,125.68l1.52-.78S239.75,126.31,238.81,125.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25,127.16l1.51-.77S232.18,127.8,231.25,127.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.52,151.91s10.83,6.8,17.09,16c0,0-7.43-.42-6.9-5.1,0,0-8.28,6.06-10.73-1.06-1.49-4.35-2.48-6.87-3-8.17a1,1,0,0,1,.78-1.35Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.52,151.91s10.83,6.8,17.09,16c0,0-7.43-.42-6.9-5.1,0,0-8.28,6.06-10.73-1.06-1.49-4.35-2.48-6.87-3-8.17a1,1,0,0,1,.78-1.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.28,160.54a31.46,31.46,0,0,1-4.39,2.21c-2.92,1.17-4.73.53-5.79-2.55-.8-2.33-2.57-6.18-3.39-7.91a1,1,0,0,0-.75,1.33c.54,1.3,1.53,3.82,3,8.17,2.45,7.12,10.73,1.06,10.73,1.06l1.63-1.26C229,161.23,228.63,160.88,228.28,160.54Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.4,151.91s2.66,6.48.21,16c0,0,6.16-3.39,3.19-6.38a6.6,6.6,0,0,1,2.13,1.1.69.69,0,0,0,1.13-.55,17.31,17.31,0,0,0-3.15-8.7A3.05,3.05,0,0,0,236,152.2Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.4,151.91s2.66,6.48.21,16c0,0,6.16-3.39,3.19-6.38a6.6,6.6,0,0,1,2.13,1.1.69.69,0,0,0,1.13-.55,17.31,17.31,0,0,0-3.15-8.7A3.05,3.05,0,0,0,236,152.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.12,152.24c2.19,3.67,3.65,8.8,3,7.94-.53-.65-2.3-.93-3.45-1,0,.49,0,1,0,1.55l2.17.88a6.6,6.6,0,0,1,2.13,1.1.69.69,0,0,0,1.13-.55,17.31,17.31,0,0,0-3.15-8.7A3,3,0,0,0,236.12,152.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.32,156.11c9.18,0,6.79,14.82,3,34.57,0,0,9.56,12.27,28.68,14.18a9.83,9.83,0,0,1,8.76-3.74s6.37-2.77,7.65,0-5.74,10.27-17.05,9.63c0,0-38.23-1.27-40.78-13.06S197.15,156.12,206.32,156.11Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,177.62s7.22-1.38,17.31,1.91c0,0,6.82-22.88-4.88-24.43C196.17,153.61,195,177.62,195,177.62Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.08,176.45a43.63,43.63,0,0,0-8.79-2.3,24.48,24.48,0,0,0-9,.29c-.23,1.92-.29,3.18-.29,3.18s7.22-1.38,17.31,1.91C212.31,179.53,212.67,178.32,213.08,176.45Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.92,183.25h-.61l-.78-2.38a.7.7,0,0,1,.66-.92H223a.7.7,0,0,1,.66.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.61,
    cy: 179.16,
    r: 1.65,
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.61,
    cy: 179.16,
    r: 1.02,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.83,
    y: 182.17,
    width: 11.57,
    height: 7.23,
    rx: 1.25,
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.83,
    y: 182.17,
    width: 11.57,
    height: 7.23,
    rx: 1.25,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.24,
    y: 182.57,
    width: 10.75,
    height: 6.41,
    rx: 0.94,
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.24,
    y: 182.57,
    width: 10.75,
    height: 6.41,
    rx: 0.94,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.37,
    y: 183.52,
    width: 2.6,
    height: 2.94,
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,184.54a.23.23,0,1,1,0-.46h4.82a.23.23,0,1,1,0,.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,187.48a.23.23,0,1,1,0-.46h4.82a.23.23,0,1,1,0,.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.07,186a.23.23,0,1,1,0-.46h4.82a.23.23,0,1,1,0,.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.14,193.87a35.76,35.76,0,0,1,9.33,3.76.5.5,0,0,0,.71-.64c-1-2.13-3.58-5.71-10-4.09A.5.5,0,0,0,229.14,193.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.47,186.63c.87.23,2.25.63,3.9,1.24a.57.57,0,0,0,.69-.81c-.57-1-1.84-2.14-4.63-1.09A.35.35,0,0,0,240.47,186.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.76,137a5.43,5.43,0,0,0,1.14-.1.2.2,0,0,0,.17-.23h0a.21.21,0,0,0-.23-.17,5.43,5.43,0,0,1-4.73-1.32.19.19,0,0,0-.28,0,.21.21,0,0,0,0,.29A5.67,5.67,0,0,0,236.76,137Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,174.65a6.64,6.64,0,0,0-6.86-6.41c-3.73.11-6.4,3.59-7.79,7.19-.21.23-.4.46-.58.69-3,3.82-.65,9.11,4.29,9.92.13,0,.26,0,.4.06h0a7,7,0,0,0,4-.61c3.17-1.48,3.91-3.41,5.89-7.86A6.56,6.56,0,0,0,259.23,174.65Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.42,174.82a.16.16,0,0,1,.1.05,1.16,1.16,0,0,0,1,.46.15.15,0,0,1,.16.13.15.15,0,0,1-.12.16h0a1.48,1.48,0,0,1-1.22-.56.15.15,0,0,1,0-.2h0A.11.11,0,0,1,245.42,174.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.4,176.18a.12.12,0,0,1,.1,0,1.17,1.17,0,0,0,1,.46.15.15,0,0,1,.16.12.15.15,0,0,1-.12.17h0a1.49,1.49,0,0,1-1.22-.56.15.15,0,0,1,0-.2h0A.11.11,0,0,1,248.4,176.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.72,179.74a.15.15,0,0,1,.11,0,1.18,1.18,0,0,0,1,.15.13.13,0,0,1,.18.08.14.14,0,0,1-.06.19h0a1.47,1.47,0,0,1-1.33-.17.17.17,0,0,1,0-.21h0A.1.1,0,0,1,245.72,179.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,176a8.14,8.14,0,0,1-1.73,1.42,1.33,1.33,0,0,0,.94.59Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.63,175l.09,0a.2.2,0,0,0,.13-.24,1.89,1.89,0,0,0-1.14-1.29.2.2,0,0,0-.24.13.18.18,0,0,0,.12.23h0a1.52,1.52,0,0,1,.9,1A.17.17,0,0,0,251.63,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.75,172.71a.17.17,0,0,0,.17,0,1.48,1.48,0,0,1,1.3-.41.19.19,0,0,0,.09-.37,1.91,1.91,0,0,0-1.66.5.19.19,0,0,0,0,.26h0A.24.24,0,0,0,245.75,172.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.48,176.3a1.07,1.07,0,1,1-1.23.89A1.08,1.08,0,0,1,244.48,176.3Z",
    style: {
      fill: "#ba4d3c",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.69,178.08a1.07,1.07,0,1,1-1.23.88A1.06,1.06,0,0,1,248.69,178.08Z",
    style: {
      fill: "#ba4d3c",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.36,185s-3-2.5-.28-6.27,3.62-6.71,1.25-7.94-4.38-3.38-2.53-4.63,1.65,1.71,5.11,4S262.25,179.65,254.36,185Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,185.8c4.17-2.64,11.93-6.9,17.13-5.79a2.37,2.37,0,0,1,1.78,1.81,9.94,9.94,0,0,1,.18,3.23,2.39,2.39,0,0,1-2.92,2.11,42.21,42.21,0,0,0-15.68-.09A.7.7,0,0,1,244,185.8Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,185.8c4.17-2.64,11.93-6.9,17.13-5.79a2.37,2.37,0,0,1,1.78,1.81,9.94,9.94,0,0,1,.18,3.23,2.39,2.39,0,0,1-2.92,2.11,42.21,42.21,0,0,0-15.68-.09A.7.7,0,0,1,244,185.8Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,184.74a11.11,11.11,0,0,1-3.28-4.47.68.68,0,0,0-1.26-.05,9,9,0,0,0-.79,3.41.69.69,0,0,0,.36.64C242.17,184.87,245.32,186.44,246.05,184.74Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.05,184.74a11.11,11.11,0,0,1-3.28-4.47.68.68,0,0,0-1.26-.05,9,9,0,0,0-.79,3.41.69.69,0,0,0,.36.64C242.17,184.87,245.32,186.44,246.05,184.74Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-120"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "294.21 394.09 295.48 408.6 302.61 408.48 304.02 394.24 294.21 394.09",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.51,405.79l8.36.17a.78.78,0,0,1,.75.62l1.6,7.9a1.29,1.29,0,0,1-1,1.53l-.27,0c-3.48-.13-6.57-.37-10.91-.45-5.12-.09-3.83.55-9.85.52-3.62,0-4.21-4.15-2.67-4.32,7.05-.76,9.12-2.87,11.88-5.34A3.1,3.1,0,0,1,295.51,405.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,252.79s-.65,29.36,4.84,79,6.67,67.31,6.67,67.31l11.39.32s5.22-35.4,4.43-60.11c-.08-2.43-.21-4.77-.42-7a94.58,94.58,0,0,1-.22-14.77h0l2.2-35.16s18.1-9.36,13.32-33.55l-24.79-9.68-11.12,1.61Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.9,252.79s-.65,29.36,4.84,79,6.67,67.31,6.67,67.31l11.39.32s5.22-35.4,4.43-60.11c-.08-2.43-.21-4.77-.42-7a94.58,94.58,0,0,1-.22-14.77h0l2.2-35.16s18.1-9.36,13.32-33.55l-24.79-9.68-11.12,1.61Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.63,245.39s-7.85,21.3,5.18,68.73l2-31.65s.27-.14.74-.44l.77-12.23a20.52,20.52,0,0,0,2.81-1.88l-3.74-17.37Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.67,400.79l10.63.55a1.84,1.84,0,0,0,1.93-1.61h0a1.84,1.84,0,0,0-1.76-2.09l-10.64-.42A1.78,1.78,0,0,0,292,399h0A1.78,1.78,0,0,0,293.67,400.79Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.67,400.79l10.63.55a1.84,1.84,0,0,0,1.93-1.61h0a1.84,1.84,0,0,0-1.76-2.09l-10.64-.42A1.78,1.78,0,0,0,292,399h0A1.78,1.78,0,0,0,293.67,400.79Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.24 391.91 343.68 405.78 350.61 404.09 348.84 389.89 339.24 391.91",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.93,403.58l8.22-1.55a.77.77,0,0,1,.86.45l3.2,7.4a1.29,1.29,0,0,1-.66,1.7,1.34,1.34,0,0,1-.26.09c-3.44.59-6.51,1-10.77,1.81-5,1-3.64,1.32-9.53,2.54-3.55.73-5-3.19-3.51-3.68,6.74-2.19,8.33-4.69,10.52-7.67A3.15,3.15,0,0,1,342.93,403.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.57,240.53s8.6,68.78,15,88.07c5.79,17.53,26.44,67.91,26.44,67.91l10.64-2.14s-4-42.66-12.68-64.39c-.31-.78-.62-1.52-.94-2.24a44.67,44.67,0,0,1-3.84-18.08v-.2c0-6.14-.06-13.72-.1-20.22,0-2.11,0-4.11,0-5.91a37.7,37.7,0,0,1,.81-7.85,38.74,38.74,0,0,0,.71-6.15c.21-5.95-.7-14.55-5.22-25.1l-23.87-10.15-5.12,3.55Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.57,240.53s8.6,68.78,15,88.07c5.79,17.53,26.44,67.91,26.44,67.91l10.64-2.14s-4-42.66-12.68-64.39c-.31-.78-.62-1.52-.94-2.24a44.67,44.67,0,0,1-3.84-18.08v-.2c0-6.14-.06-13.72-.1-20.22,0-2.11,0-4.11,0-5.91a37.7,37.7,0,0,1,.81-7.85,38.74,38.74,0,0,0,.71-6.15c.21-5.95-.7-14.55-5.22-25.1l-23.87-10.15-5.12,3.55Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.36,398.53l10.41-2.21a1.86,1.86,0,0,0,1.45-2.06h0A1.85,1.85,0,0,0,350,392.7l-10.38,2.35a1.77,1.77,0,0,0-1.33,2.2h0A1.78,1.78,0,0,0,340.36,398.53Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.36,398.53l10.41-2.21a1.86,1.86,0,0,0,1.45-2.06h0A1.85,1.85,0,0,0,350,392.7l-10.38,2.35a1.77,1.77,0,0,0-1.33,2.2h0A1.78,1.78,0,0,0,340.36,398.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.47,172.85s-8,23.48-2.24,28,12.15-25.7,12.15-25.7Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.7,156.69s-13.25-1.33-14.44,23.94c0,0,3.08,4.74,14.44,3.45C288.7,184.08,294.54,160.81,288.7,156.69Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.43,178.12c-.07.81-.12,1.64-.17,2.51,0,0,3.08,4.74,14.44,3.45,0,0,.24-1,.57-2.51A21.49,21.49,0,0,1,274.43,178.12Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.89,184c4.49-10.83,11.08-28.41,4.64-24.17-7,4.62-9.9,16.19-10.86,21.33A11.37,11.37,0,0,0,280.89,184Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.17,180.34l-1.24-.3-6.7,14-.4,1.85L280,198C282.59,193.52,284.85,185.59,286.17,180.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.24,245.37,302,253.1a9,9,0,0,0,9.07,5.07,96.45,96.45,0,0,0,23.36-5.27s-3.71-13.31-10.54-33.55c-2.81-8.31-4.09-18.93-.43-35.06,3.62-16,12.51-37-34.71-27.6a3.37,3.37,0,0,0-2.22,1.54c-3.22,5.15-14.59,24.82-5.66,32.08,0,0,3.16,22.88,2.8,30.54-.44,9.36-5.16,20.65-3.44,37.42,0,0,5,.61,12.58.72a5.4,5.4,0,0,0,5.48-5.39Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.38,160.54l7.95-5.91c-4.8-.57-11.23-.26-19.74,1.16l-2,10.3.88,5.58,6.66-4.77Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.49,178.12a51,51,0,0,1,14.52.35v2.16a71.9,71.9,0,0,0-14.52,0Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.16,
    y: 229.24,
    width: 9.25,
    height: 1.72,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.45 229.29 318.54 228 319.04 229.67 305.92 230.96 305.45 229.29",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.41,184.29c.94-4.17,2.24-8.68,2.82-12.91l-7.77-10.16-2.26,2.15S311.62,174,322,191.85C322.34,189.47,322.8,187,323.41,184.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.33,114.37s-6.37-5.67-2.78-9c3.12-2.87,5.1,1.1,8.4,0s6.4-4.54,10.12-.41-1.24,6.6,1,9.39,3.16,7.84-.48,8.29c-3,.38-3.6-1.59-5.44,1s-5.51,5.12-8.19,1S308.33,114.37,308.33,114.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.1,110.21a16,16,0,0,0,3.23,4.16,23.65,23.65,0,0,0,2,9.28c1.56,1.66,3.18,2.9,4.71,3.16a7.34,7.34,0,0,0,4.11-3.1,3.73,3.73,0,0,1,1.15-1.19c.88-3.7-.94-8.68-3.95-11.39S308.28,109.32,305.1,110.21Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.63,117.84a5.89,5.89,0,1,1-5.89-5.89A5.89,5.89,0,0,1,317.63,117.84Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.54,133c1.52-2.86-.63-8.68-4.34-11.24,5.43-8.85-10.58-12.91-18.76-12.39s-4.72,3.67-11.51,5.76-2.83,10.76-.42,12.66C290.46,133.29,313,143.53,318.54,133Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.52,137.55c-.3,5.4,0,15.16,4.19,18.15,0,0-4,4.59-12.42,9.85-6.51-4-3.9-7.56-3.9-7.56,5.65-2.25,4.89-6.55,3.35-10.48Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.92,141.65l-5.22,5.9a17.49,17.49,0,0,1,.91,2.82c2.19-.64,5.28-3.11,5.19-5.49A9.58,9.58,0,0,0,302.92,141.65Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,129c-1.79,8.69-2.36,12.41-7.43,16.28-7.62,5.82-17.9,1.73-18.75-7.32-.77-8.15,2.28-21,11.35-23.26A12.1,12.1,0,0,1,310.8,129Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.88,136.18a6.41,6.41,0,0,1-3.63,3.36c-2.14.77-3.38-1.1-2.92-3.21.41-1.89,2-4.57,4.23-4.44a2.93,2.93,0,0,1,2.65,3.19A2.65,2.65,0,0,1,311.88,136.18Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.85,112c1.67,2.55-1.9,7.63-10,7.59-6.08,0-13.33,6.88-13.09-.19C283,112.93,298,109.05,305.85,112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.46,114.09c-3.87,3.3-.89,8.79,1.19,11.22s5.19,4.64,3.08,8.52-2.4,16,4.14,12.07c2.82-1.69,6.3-14.51,3.85-20.09S306.07,110.16,301.46,114.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.29,129.94a19.21,19.21,0,0,1-3.2,4.2,3.15,3.15,0,0,0,2.48.85Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.92,126.43a.27.27,0,0,0,.17-.06.34.34,0,0,0,.1-.48h0A4.11,4.11,0,0,0,297.9,124a.36.36,0,0,0-.35.36.35.35,0,0,0,.35.34,3.48,3.48,0,0,1,2.71,1.59A.35.35,0,0,0,300.92,126.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.77,124.4a.49.49,0,0,0,.17-.06A3.45,3.45,0,0,1,289,124a.35.35,0,0,0,.47-.17h0a.36.36,0,0,0-.18-.47,4.16,4.16,0,0,0-3.77.41.36.36,0,0,0-.13.49.37.37,0,0,0,.34.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.49,129.48c-.09.71-.56,1.23-1,1.17s-.76-.7-.65-1.42.56-1.23,1-1.17S297.59,128.76,297.49,129.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.42,128.33c-.1.71-.56,1.23-1,1.17s-.76-.69-.66-1.41.56-1.24,1-1.17S289.53,127.61,289.42,128.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,127l-1.64-.73S288,127.71,289,127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,128.13l-1.64-.73S296.08,128.86,297,128.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.06,138.85a6.27,6.27,0,0,1-1.14-.1.19.19,0,0,1-.16-.22h0a.2.2,0,0,1,.23-.16,5.4,5.4,0,0,0,4.66-1.3.2.2,0,0,1,.28,0,.21.21,0,0,1,0,.29A5.55,5.55,0,0,1,292.06,138.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23,154.23s-12.07,7.65-19.81,17.44c0,0,7.68-1,7.8-5.65,0,0,7.63,5.51,11.15-1.85,2.15-4.5,3.52-7.12,4.26-8.47a.81.81,0,0,0-.6-1.3Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23,154.23s-12.07,7.65-19.81,17.44c0,0,7.68-1,7.8-5.65,0,0,7.63,5.51,11.15-1.85,2.15-4.5,3.52-7.12,4.26-8.47a.81.81,0,0,0-.6-1.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,163.72a25.39,25.39,0,0,0,4.18,1.92c2.83,1,4.77.19,6.3-3,1.16-2.41,3.52-6.42,4.6-8.23a.81.81,0,0,1,.58,1.29c-.74,1.35-2.11,4-4.26,8.47-3.52,7.36-11.15,1.85-11.15,1.85l-1.49-1.16C299.14,164.47,299.55,164.09,300,163.72Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.92,155.44a29.36,29.36,0,0,0-2.5,16.23s-5.84-3-2.36-6.22a8.64,8.64,0,0,0-2.34,1.26c-.54.41-1.22.13-1.09-.47a21.65,21.65,0,0,1,4.47-9,4.16,4.16,0,0,1,2.14-1.36Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.92,155.44a29.36,29.36,0,0,0-2.5,16.23s-5.84-3-2.36-6.22a8.64,8.64,0,0,0-2.34,1.26c-.54.41-1.22.13-1.09-.47a21.65,21.65,0,0,1,4.47-9,4.16,4.16,0,0,1,2.14-1.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M293.11,155.9c-2.77,3.87-5,9.16-4.16,8.24.63-.69,2.49-1.1,3.68-1.3-.08.5-.16,1-.22,1.56l-2.35,1a8.64,8.64,0,0,0-2.34,1.26c-.54.41-1.22.13-1.09-.47a21.65,21.65,0,0,1,4.47-9A4.15,4.15,0,0,1,293.11,155.9Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.56,183.85h-.62l-.79-2.41a.7.7,0,0,1,.67-.92h.86a.7.7,0,0,1,.67.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.92,179.71a1.67,1.67,0,1,1-1.67-1.67A1.67,1.67,0,0,1,307.92,179.71Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.28,179.71a1,1,0,1,1-1-1A1,1,0,0,1,307.28,179.71Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.39,
    y: 182.76,
    width: 11.71,
    height: 7.32,
    rx: 1.25,
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.39,
    y: 182.76,
    width: 11.71,
    height: 7.32,
    rx: 1.25,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.81,
    y: 183.17,
    width: 10.89,
    height: 6.49,
    rx: 0.96,
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.81,
    y: 183.17,
    width: 10.89,
    height: 6.49,
    rx: 0.96,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.95,
    y: 184.13,
    width: 2.63,
    height: 2.97,
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,185.17a.24.24,0,0,1,0-.48h4.88a.24.24,0,0,1,0,.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,188.14a.24.24,0,0,1-.24-.24.23.23,0,0,1,.24-.23h4.88a.23.23,0,0,1,.23.23.23.23,0,0,1-.23.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,186.65a.23.23,0,0,1-.24-.23.24.24,0,0,1,.24-.24h4.88a.23.23,0,0,1,.23.24.23.23,0,0,1-.23.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.55,204.9c2.71-9.5-4.21-32.05-4.21-32.05l-9.44,5.41s4.58,17.66,4.59,22a1.63,1.63,0,0,0,.69,1.37l5.89,4.1A1.61,1.61,0,0,0,333.55,204.9Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.05,158.17c2.66-1.11,9.24-.8,12.3,18.46,0,0-4.52,7.27-13,7.93C319.35,184.56,310.07,162.35,320.05,158.17Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.35,176.63c-.12-.78-.25-1.51-.39-2.23-6.62,6.65-11.49,7.68-13.51,7.76.52,1.48.9,2.4.9,2.4C327.83,183.9,332.35,176.63,332.35,176.63Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.41,202.07c-3.86-3.36-6.29-7.47-2.51-12,3.13-3.76,9.19-1.32,12.35.35a3.09,3.09,0,0,0,3.48-.37,14.28,14.28,0,0,1,8.93-3.45A4.47,4.47,0,0,0,310,185c3.06-3.75,11.22-12.39,18.1-7.61,8.65,6,3.92,20.75-9.94,27.45S290.84,207.68,284.41,202.07Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.41,202.07c-3.86-3.36-6.29-7.47-2.51-12,3.13-3.76,9.19-1.32,12.35.35a3.09,3.09,0,0,0,3.48-.37,14.28,14.28,0,0,1,8.93-3.45A4.47,4.47,0,0,0,310,185c3.06-3.75,11.22-12.39,18.1-7.61,8.65,6,3.92,20.75-9.94,27.45S290.84,207.68,284.41,202.07Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.25,191.75a5.08,5.08,0,0,0-5.11-.63c-2.62,4.11-.29,7.85,3.27,10.95,6.43,5.61,19.84,9.5,33.7,2.79.45-.21.85-.45,1.28-.68C294.71,209.69,289.6,194.4,286.25,191.75Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.81,191.87a36.44,36.44,0,0,1,8.69,5.29.51.51,0,0,0,.82-.52c-.61-2.29-2.63-6.29-9.35-5.74A.51.51,0,0,0,297.81,191.87Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.32,186.5c.83.37,2.14,1,3.69,1.89a.58.58,0,0,0,.83-.7c-.4-1.12-1.49-2.44-4.45-1.85A.35.35,0,0,0,310.32,186.5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,177.63a6.72,6.72,0,0,0-5.8-7.53c-3.74-.5-7,2.53-9,5.9-.24.19-.47.39-.69.59-3.61,3.32-2.15,9,2.65,10.61l.38.14h0a7.05,7.05,0,0,0,4.13.06c3.41-1,4.47-2.76,7.18-6.87A6.74,6.74,0,0,0,331,177.63Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,175.53a.15.15,0,0,1,.09.06,1.2,1.2,0,0,0,.89.62.13.13,0,0,1,.13.15.14.14,0,0,1-.14.14h0a1.44,1.44,0,0,1-1.12-.76.14.14,0,0,1,.06-.19h0A.12.12,0,0,1,317.21,175.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,177.38a.15.15,0,0,1,.09.06,1.21,1.21,0,0,0,.88.62.15.15,0,0,1,0,.29h0a1.47,1.47,0,0,1-1.12-.76.13.13,0,0,1,.07-.19h0A.12.12,0,0,1,320,177.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.23,181.25a.12.12,0,0,1,0-.1,1.21,1.21,0,0,0,.5-1,.15.15,0,1,1,.29,0h0a1.48,1.48,0,0,1-.61,1.22.16.16,0,0,1-.2,0h0A.19.19,0,0,1,316.23,181.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.61,176.92a8.75,8.75,0,0,1-2,1.13,1.32,1.32,0,0,0,.84.74Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.57,176.6a.17.17,0,0,0,.1,0,.18.18,0,0,0,.11-.24,1.9,1.9,0,0,0-1.25-1.22.19.19,0,0,0-.23.14.2.2,0,0,0,.14.24h0a1.46,1.46,0,0,1,1,1A.18.18,0,0,0,323.57,176.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.84,173.22a.2.2,0,0,0,.18,0,1.5,1.5,0,0,1,1.36.2.18.18,0,0,0,.27,0,.18.18,0,0,0,0-.26,1.88,1.88,0,0,0-1.73-.28.18.18,0,0,0-.13.23h0A.18.18,0,0,0,317.84,173.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,176.85a1.07,1.07,0,0,1,.68,1.37,1.08,1.08,0,1,1-.68-1.37Z",
    style: {
      fill: "#ba4d3c",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.94,179.32a1.08,1.08,0,1,1-1.38.68A1.08,1.08,0,0,1,319.94,179.32Z",
    style: {
      fill: "#ba4d3c",
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.31,186.28s-1.05-2.53,1.48-5.18,3.2-5.29,2.58-6.24-4.85.68-2.41-1.58c0,0-3.72.38-2-1.22,0,0-3.43.45-1.74-.86,0,0-3.1.22-2-.58s6.12-2.18,8.95,2S331,182.37,325.31,186.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.5,181.68c-1,.64-1.54,1.76-1.18,2.48s1.49.79,2.5.15,1.55-1.76,1.18-2.49S326.51,181,325.5,181.68Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,186.26c4.6-1.95,13.06-4.92,18.07-3a2.41,2.41,0,0,1,1.48,2.11,10.21,10.21,0,0,1-.35,3.25,2.43,2.43,0,0,1-3.27,1.62,43,43,0,0,0-15.65-2.68A.7.7,0,0,1,314,186.26Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,186.26c4.6-1.95,13.06-4.92,18.07-3a2.41,2.41,0,0,1,1.48,2.11,10.21,10.21,0,0,1-.35,3.25,2.43,2.43,0,0,1-3.27,1.62,43,43,0,0,0-15.65-2.68A.7.7,0,0,1,314,186.26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.2,185.53a11.34,11.34,0,0,1-2.54-5,.69.69,0,0,0-1.25-.26,9.33,9.33,0,0,0-1.35,3.27.74.74,0,0,0,.25.71C312.3,185,315.19,187.11,316.2,185.53Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.2,185.53a11.34,11.34,0,0,1-2.54-5,.69.69,0,0,0-1.25-.26,9.33,9.33,0,0,0-1.35,3.27.74.74,0,0,0,.25.71C312.3,185,315.19,187.11,316.2,185.53Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.56,194.2a26.08,26.08,0,0,0,10.3,9.88l8.87,1.61,1,.86a2.59,2.59,0,0,1-.14,4l-3.82,2.85a2.6,2.6,0,0,1-3.3-.17l-4.25-3.92s-11.37-.86-14-9.62c-.4-1.38,2.19-5.33,2.19-5.33A1.73,1.73,0,0,1,279.56,194.2Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.4,209.57a2.57,2.57,0,0,0-.67-3l-1-.86-8.87-1.61-.1-.06c.73,1.83,2.24,5,4.2,5.76C295.63,210.42,298.43,210,300.4,209.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.72,206.89c-4.28,8-27,.44-27,.44l-10.12.14a3.45,3.45,0,0,1-2.59-1.14l-1.36-1.54a3.39,3.39,0,0,1-.65-3.41l.71-1.94a3.39,3.39,0,0,1,4.71-1.87l9,4.55s18.05.93,19-1c0,0,1-2.81,4.92-1.63S334.49,203.57,332.72,206.89Z",
    style: {
      fill: "#ce7a63"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctors3);
export default __webpack_public_path__ + "static/media/Doctors3.a71c4a9cfe66b3f67c986cd89bd9089b.svg";
export { ForwardRef as ReactComponent };